import React, { Fragment, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { number, bool, shape, arrayOf, func, string, object } from 'prop-types';
import { connect } from 'react-redux';
import { Button, Link, withStyles } from '@material-ui/core';
import { push } from 'connected-react-router';
import compose from 'recompose/compose';
import moment from 'moment';
import clsx from 'clsx';
import { filter } from 'lodash';

import styles from './styles';
import DetailsContainer from '../../details';
import {
  AlertDialog, DetailsHeader,
  TabPanel, TabsContainer,
} from '../../../components';
import {
  ALERT_ERROR,
  ALERT_SUCCESS,
  FAIL,
  GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
  SUCCESS,
  APPLICATION_REQUEST_LIST_TYPES,
  REQUESTS_FILTER_EMAIL_TYPE,
  REQUEST_FILTER_CONTAINS,
  SERVER_DATE_FORMAT,
  getOrgBoundRoles,
} from '../../../constants';
import {
  fetchList,
  fetchOrgSuggestions,
  submitBulkRegistrationRequests,
  submitRequest,
} from '../../../actions/requests';
import {
  getIsLoading,
  getListTotalPages,
  getListTotalElements,
  getListResults,
  getOrgSuggestions,
  getRequestUpdateStatus,
  getErrors,
  getRequestBulkUpdateStatus,
  getRequestBulkUpdateResults,
  getBulkSubmitError,
} from '../../../reducers/request';
import { getI18n, getI18nFormattedMessage } from '../../../utils/intl';
import { hasDeveloperRole, hasAdminRole, getTabIndex } from '../../../utils';
import { getUserDetails } from '../../../reducers/portalConfig';
import { ApplicationRequestsList } from "./Applications";
import { UserRequestsList } from "./Users";
import { format } from "date-fns";
import { AlertDialogInnerComponent } from "../AppRequestDetails";
import { List, ListItem, ListItemText } from "@material-ui/core/";
import get from "lodash/get";

const APPLICATION_REQUESTS_LIST_TAB = 'application-requests-list-tab';
const USER_REQUESTS_LIST_TAB = 'user-requests-list-tab';

const getTabItems = ({ user }) => [
  {
    id: "application",
    tabId: APPLICATION_REQUESTS_LIST_TAB,
    label: getI18nFormattedMessage('label.request.applications.title'),
    filterType: 'ALL_APPLICATION_TYPES',
    visible: true,
  },
  {
    id: "user",
    tabId: USER_REQUESTS_LIST_TAB,
    label: getI18nFormattedMessage('label.request.users.title'),
    filterType: 'REGISTRATION',
    visible: hasAdminRole(user),
  },
];

const getTabs = (tabItems) => tabItems.filter(({ visible }) => visible);

export const RequestsList = (props) => {
  const {
    classes,
    fetchList,
    fetchOrgSuggestions,
    isLoading = false,
    orgSuggestions,
    requestUpdateStatus,
    requestBulkUpdateStatus,
    requestBulkUpdateResults,
    results = [],
    submitRequest,
    submitBulkRegistrationRequests,
    totalElements = 0,
    totalPages,
    user,
    errors,
    bulkSubmitError,
  } = props;
  const intl = getI18n(useIntl());
  const { getI18nMessage } = intl;
  const [alertReason, setAlertReason] = useState('');
  const [requestIds, setRequestIds] = useState('');
  const [isAcceptAction, setIsAcceptAction] = useState(true);
  const [disableActionSubmit, setDisableActionSubmit] = useState(false);
  const [shouldNotifyUser, setShouldNotifyUser] = useState(false);
  const [shouldAssignOrgRole, setShouldAssignOrgRole] = useState(false);
  const [assignedOrg, setAssignedOrg] = useState({ uuid : '', name : '' });
  const [assignedOrgSearchText, setAssignedOrgSearchText] = useState('');
  const assignRoleOptions = getOrgBoundRoles(intl);
  const [assignedRole, setAssignedRole] = useState(assignRoleOptions[0].uuid);
  const [userEmail, setUserEmail] = useState('');
  const [userEmailError, setUserEmailError] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const onAlertReasonChange = (value) => {
    setAlertReason(value);
    if (!isAcceptAction) {
      if (value) {
        setDisableActionSubmit(false);
      } else {
        setDisableActionSubmit(true);
      }
    }
  };

  const onAssignedRoleChange = (role) => setAssignedRole(role);
  const onShouldNotifyUserChange = () => setShouldNotifyUser(shouldNotifyUser => !shouldNotifyUser)

  const getAlertDialogInnerComponent = () => {
    if (isBulkError) {
      return (
        <List style={classes.alertDialogErrorMessagesClass}>
          {bulkErrorMessages.map((errorMessage, index)=>(
            <>
              <ListItem key={index}>
                <ListItemText primary={`\u25CF Email : ${errorMessage.email}`} />
              </ListItem>
              <ListItem key={index}>
                <ListItemText primary={`${errorMessage.error} (${errorMessage.errorCode})`} />
              </ListItem>
            </>
          ))}
        </List>
      )
    } else {
      return <AlertDialogInnerComponent
        classes={classes}
        requestType={currentTab === APPLICATION_REQUESTS_LIST_TAB ?
          'APPLICATION' : 'REGISTRATION'}
        isAcceptAction={isAcceptAction}
        userEmail={userEmail}
        userEmailError={userEmailError}
        onUserEmailChange={onUserEmailChange}
        getI18nMessage={getI18nMessage}
        shouldAssignOrgRole={shouldAssignOrgRole}
        setShouldAssignOrgRole={setShouldAssignOrgRole}
        orgSuggestions={orgSuggestions}
        assignedOrgSearchText={assignedOrgSearchText}
        onAssignedOrgSearchTextChange={onAssignedOrgSearchTextChange}
        assignedOrg={assignedOrg}
        onAssignedOrgChange={onAssignedOrgChange}
        assignedRole={assignedRole}
        onAssignedRoleChange={onAssignedRoleChange}
        assignRoleOptions={assignRoleOptions}
        shouldNotifyUser={shouldNotifyUser}
        onShouldNotifyUserChange={onShouldNotifyUserChange}
        alertReason={alertReason}
        onAlertReasonChange={onAlertReasonChange}
        isBulkRequest={requestIds.length > 1}
      />
    }
  }

  const [notificationStatus, setNotificationStatus] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [filterByName, setFilterByName] = useState('');
  const [filterByEmail, setFilterByEmail] = useState('');
  const [filterByEmailType, setFilterByEmailType] = useState(REQUEST_FILTER_CONTAINS)
  const [filterByType, setFilterByType] = useState('ALL_APPLICATION_TYPES');
  const [filterByOrg, setFilterByOrg] = useState({ uuid : '', name : '' });
  const [orgSearchText, setOrgSearchText] = useState('');
  const [filterByStartDate, setFilterByStartDate] = useState();
  const [filterByEndDate, setFilterByEndDate] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(GRID_ROWS_PER_PAGE_DEFAULT_OPTION);
  const [showActionAlert, setShowActionAlert] = useState(false);
  const [actionAlertTitle, setActionAlertTitle] = useState('');
  const [alertSubmitText, setAlertSubmitText] = useState('Accept');
  const [isReviewSubmitted, setReviewSubmitted] = useState(false);
  const [bulkErrorMessages, setBulkErrorMessage] = useState([]);
  const [isBulkError, setIsBulkError] = useState(false);
  const [actionAlertDesc, setActionAlertDesc] = useState(getI18nMessage('label.request.list.actions.alert.description'));
  const emptyFunction = () => {};

  useEffect(() => {
    if (!isAcceptAction) {
      setDisableActionSubmit(false);
      if(currentTab === APPLICATION_REQUESTS_LIST_TAB && !alertReason) {
        setDisableActionSubmit(true);
      }
      if(currentTab === USER_REQUESTS_LIST_TAB && shouldNotifyUser && !alertReason) {
        setDisableActionSubmit(true);
      }
    }
  }, [shouldNotifyUser, showActionAlert])

  const notifyMessages = (status, message, timeout) => {
    setNotificationStatus(status);
    setNotificationMessage(message);
    if(timeout) {
      setTimeout(() => {
        setNotificationMessage('');
        setNotificationStatus('');
      }, timeout);
    }
  }

  const getLinkContent = (value = '', uuid) => (
    <Link underline="none" href={`/admin/console/requests/details/${uuid}`}>
      {value}
    </Link>
  );

  const getListColumns = ({ getI18nMessage, classes }) => [{
    id: 'entityName',
    label: currentTab === "application-requests-list-tab" ?
      getI18nMessage('label.application') :
      getI18nMessage('label.request.details.email.field.value'),
    minWidth: 200,
    value: ({ entityUuid, entityName }) => {
      return { entityUuid, entityName };
    },
    format: ({ entityUuid, entityName }) => {
      const linkEl = getLinkContent(entityName, entityUuid)
      return linkEl;
    },
  },{
    id: 'modifiedBy',
    label: getI18nMessage('label.modifiedBy'),
    minWidth: 200,
    format: (value) => value,
    isHidden: currentTab !== "application-requests-list-tab",
  }, {
    id: 'organizationName',
    label: getI18nMessage('label.request.list.organization.name'),
    minWidth: 200,
    format: (orgName) => (
      <div onClick={() => setSelectedRows.length < 1 && onOrgSelection({ name : orgName })}>
        {orgName}
      </div>
    ),
  }, {
    id: 'modifyTs',
    label: getI18nFormattedMessage('label.request.list.request.date.name'),
    minWidth: 200,
    format: (value) => moment(value).format('MMMM DD, YYYY'),
  }, {
    id: 'actionable',
    label: getI18nFormattedMessage('label.request.list.actions.name'),
    minWidth: 200,
    format: (value, secondaryValue, uuid) =>
      (<Fragment>
        <Button
          className={clsx(classes.actionBtn, classes.acceptBtn)}
          onClick={() => handleAccept([uuid])}
          variant="text"
        >
          {getI18nMessage('label.request.list.actions.accept')}
        </Button>
        <Button
          className={clsx(classes.actionBtn, classes.rejectBtn)}
          onClick={() => handleReject([uuid])}
          variant="text"
        >
          {getI18nMessage('label.request.list.actions.reject')}
        </Button>
      </Fragment>),
  }];

  const handleAccept = (uuids = []) => {
    if(uuids.length === 1) prefillAlertDialogFromUserRequest(uuids[0]);
    if(currentTab === USER_REQUESTS_LIST_TAB) fetchOrgSuggestions({ name : '', status : "ENABLED" })
    setActionAlertTitle(getAlertTitle(uuids, 'accept'));
    setActionAlertDesc(getI18nMessage('label.request.list.actions.alert.description'));
    setAlertSubmitText(getI18nMessage('label.request.list.actions.accept'));
    setRequestIds(uuids);
    setIsAcceptAction(true);
    setDisableActionSubmit(false);
    setAlertReason('');
    setShowActionAlert(true);
  };

  const handleReject = (uuids = []) => {
    if(uuids.length === 1) prefillAlertDialogFromUserRequest(uuids[0]);
    setActionAlertTitle(getAlertTitle(uuids, 'reject'));
    setActionAlertDesc(getI18nMessage('label.request.list.actions.alert.description'));
    setAlertSubmitText(getI18nMessage('label.request.list.actions.reject'));
    setRequestIds(uuids);
    setIsAcceptAction(false);
    setAlertReason('');
    setShowActionAlert(true);
  };

  const prefillAlertDialogFromUserRequest = (uuid) => {
    const selectedRequest = results.find(res => res.uuid === uuid);
    setUserEmail(selectedRequest.entityName);
  }

  const getAlertTitle = (uuids, type) => {
    if(uuids.length > 1) {
      return getI18nMessage(`label.request.list.actions.alert.bulk.${type}.title`, { count: uuids.length })
    }
    return getI18nMessage(`label.request.list.actions.alert.${type}.title`)
  }

  const onUserEmailChange = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    setUserEmail(email);
    setUserEmailError(!emailRegex.test(email));
  }

  const onAssignedOrgChange = (org = {}) => {
    if(!org) org = { uuid : '', name : '' }
    setAssignedOrg(org);
    setAssignedOrgSearchText(org.name);
  };

  const onAssignedOrgSearchTextChange = (orgSearchText = '') => {
    fetchOrgSuggestions({ name: orgSearchText, status : "ENABLED" });
    setAssignedOrgSearchText(orgSearchText);
  };

  const handleClose = () => {
    setShowActionAlert(false);
    fetchOrgSuggestions({ name : '' })
    clearAlertDialogState();
    notifyMessages('', '');
  };

  const clearAlertDialogState = () => {
    setActionAlertTitle('');
    setActionAlertDesc('');
    setBulkErrorMessage([]);
    setIsBulkError(false);
    setUserEmail('');
    setAssignedOrgSearchText('');
    setShouldNotifyUser(false);
    setShouldAssignOrgRole(false);
    setAssignedOrg({ uuid : '', name : '' });
    setAssignedRole(assignRoleOptions[0].uuid);
    setAlertReason('');
  }

  const resetToInitialState = () => {
    setBulkErrorMessage([]);
    setIsBulkError(false);
    setSelectedRows([]);
    setNotificationMessage('','');
    clearAlertDialogState();
    setShowActionAlert(false);
  }

  const handleSubmit = () => {
    if(isBulkError) {
      handleClose();
    } else {
      setReviewSubmitted(true);
      const payload = {
        isAccept: isAcceptAction,
        ...(requestIds.length === 1 ? { requestId: requestIds[0] } : { requestIds }),
      }
      if(currentTab === APPLICATION_REQUESTS_LIST_TAB) {
        payload['reason'] = alertReason ? alertReason : '';
      }
      if(currentTab === USER_REQUESTS_LIST_TAB) {
        if(shouldAssignOrgRole) {
          payload['assignedOrg'] = assignedOrg.uuid;
          payload['assignedRole'] = assignedRole;
        }
        payload['userEmail'] = userEmail;
        payload['shouldNotifyUser'] = shouldNotifyUser;
        payload['reason'] = shouldNotifyUser && alertReason ? alertReason : '';
      }
      if(requestIds.length > 1 && currentTab === USER_REQUESTS_LIST_TAB) {
        submitBulkRegistrationRequests(payload);
      } else {
        submitRequest(payload);
      }
      fetchOrgSuggestions({ name : '' });
      setSelectedRows([]);
      handleClose();
    }
  }

  useEffect(() => {
    if(hasDeveloperRole(user)) {
      props.push('/404');
    }
    setNotificationStatus(localStorage.getItem('notificationStatusRequestSaveSuccess'));
    setNotificationMessage(localStorage.getItem('notificationMessageRequestSaveSuccess'))
    localStorage.setItem('notificationStatusRequestSaveSuccess', '');
    localStorage.setItem('notificationMessageRequestSaveSuccess', '');
    fetchListWithFilters({ pageNum: page, rowsPerPageArg: rowsPerPage });
    fetchOrgSuggestions({ name: '' });
    setTimeout(() => {
      setNotificationMessage('');
      setNotificationStatus('');
    }, 3000);
  }, []);

  useEffect(() => {
    if (requestUpdateStatus) {
      setShowActionAlert(false);
      setAlertReason('');
      if (requestUpdateStatus === SUCCESS && isReviewSubmitted) {
        setNotificationStatus(ALERT_SUCCESS);
        if (isAcceptAction) {
          setNotificationMessage(getI18nMessage('label.request.list.actions.accept.success'));
        } else {
          setNotificationMessage(getI18nMessage('label.request.list.actions.reject.success'));
        }
      } else if (requestUpdateStatus === FAIL) {
        setNotificationStatus(ALERT_ERROR);
        if (isAcceptAction) {
          if(errors && errors.length > 0 && errors[0].field === 'proxyCheck') {
            setNotificationMessage(errors[0].error);
          } else {
            const userErrorKey = get(errors[0],'response.data.error.detail.userErrorKey','');
            if(userErrorKey === 'error.resource.not.found') {
              setNotificationMessage(getI18nMessage('label.request.list.actions.accept.fail'));
            } else {
              const userErrorMessage = get(
                errors[0],
                'response.data.error.detail.userErrorMessage',
                getDefaultErrorMessage(),
              );
              setNotificationMessage(userErrorMessage);
            }
          }
        } else {
          setNotificationMessage(getI18nMessage('label.request.list.actions.reject.fail'));
        }
      }
      setPage(0);
      fetchListWithFilters({ pageNum: 0 });
    }
  }, [requestUpdateStatus]);

  const onClickMoreInfo = () => {
    setActionAlertTitle(getI18nMessage('label.request.list.actions.alert.error.title'));
    setActionAlertDesc('');
    setAlertSubmitText(getI18nMessage('label.request.list.actions.ok'));
    setShowActionAlert(true);
  }

  const getMoreInfoLink = (onClickHandler) =>
    <Link
      component="button"
      variant="body2"
      onClick={onClickHandler}
    >
      More Information
    </Link>

  useEffect(()=> {
    if(requestBulkUpdateStatus) {
      resetToInitialState();
      if (requestBulkUpdateStatus === SUCCESS) {
        if (requestBulkUpdateResults && Object.keys(requestBulkUpdateResults).length > 0) {
          const {
            hasErrors,
            errorCount,
            bulkRegistrationReviewActionResults,
          } = requestBulkUpdateResults;
          /* If bulk requests were successfully updated, check for partial failures */
          if (hasErrors && errorCount > 0) {
            const errorMessages = []
            bulkRegistrationReviewActionResults.map(actionResult => {
              const request = results.find(req => req.uuid === actionResult.registrationUuid);
              if (request && actionResult.hasErrors) {
                setSelectedRows(selectedRows => [...selectedRows, actionResult.registrationUuid]);
                errorMessages.push({
                  email: request.entityName,
                  error: get(actionResult, 'errorResponse.error.detail.userErrorMessage', ''),
                  errorCode: get(actionResult, 'errorResponse.error.detail.errorCode', ''),
                })
              }
            })
            setIsBulkError(true);
            setBulkErrorMessage(bulkErrorMessages => [...bulkErrorMessages, ...errorMessages]);
            notifyMessages(ALERT_ERROR, (
              <>
                {`${errorCount} Error(s) ${isAcceptAction ? 'Accepting' : 'Rejecting'} user requests (which are selected below).`}
                {getMoreInfoLink(onClickMoreInfo)}
              </>
            ));
          } else {
            setIsBulkError(false);
            setBulkErrorMessage([]);
            setSelectedRows([]);
            const successCount = bulkRegistrationReviewActionResults.length;
            const message = `${successCount} ` + getDefaultSuccessMessage();
            notifyMessages(ALERT_SUCCESS, message, 3000);
            setPage(0);
            fetchListWithFilters({ pageNum: 0 });
          }
        }
      } else {
        if(bulkSubmitError) {
          const message = get(bulkSubmitError, 'error.detail.userErrorMessage', getDefaultErrorMessage());
          notifyMessages(ALERT_ERROR, message);
        }
      }
    }
  },[requestBulkUpdateStatus])

  const getDefaultSuccessMessage = () => getI18nMessage((
    isAcceptAction ? 'label.request.list.actions.accept.success' :
    'label.request.list.actions.reject.success'
  ))

  const getDefaultErrorMessage = () => getI18nMessage((
    isAcceptAction ? 'label.request.list.actions.accept.fail' :
      'label.request.list.actions.reject.fail'
  ))

  const onChangePage = (newPage) => {
    if (page === newPage) { return; }
    setPage(newPage);
    fetchListWithFilters({ pageNum: newPage });
  };
  const onChangePreviousPage = () => { onChangePage(page - 1); };
  const onChangeNextPage = () => { onChangePage(page + 1); };

  const onChangeRowsPerPage = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchListWithFilters({ pageNum: 0, rowsPerPageArg : newRowsPerPage });
  };

  const fetchListWithFilters = ({
    entityField = filterByName || filterByEmail,
    emailType = filterByEmailType,
    startDate = filterByStartDate,
    endDate = filterByEndDate,
    org = filterByOrg,
    type = filterByType,
    pageNum = page,
    rowsPerPageArg = rowsPerPage,
  } = { }) => {
    fetchList({
      filterByEntityField : entityField,
      filterByEntityFieldType : emailType,
      filterByOrg: org.name,
      filterByType : type,
      filterByStartDate : startDate && format(startDate, SERVER_DATE_FORMAT),
      filterByEndDate :  endDate && format(endDate, SERVER_DATE_FORMAT),
      page: pageNum,
      size: rowsPerPageArg,
    });
  };

  const onFilterByFieldKeyPress = (e) => {
    e.stopPropagation();
    if (e.key === 'Enter' && validateEntityName(e.target.value)) {
      setPage(0);
      fetchListWithFilters({ pageNum: 0 });
    }
  };

  const onFilterByNameChange = (value) => {
    validateEntityName(value);
    setFilterByName(value);
  };

  const onFilterByEmailChange = (value) => {
    validateEntityName(value);
    setFilterByEmail(value);
  };

  useEffect(() => fetchListWithFilters({ pageNum: 0 }),
    [filterByStartDate, filterByEndDate])

  const onFilterByStartDateChange = (date) => {
    setFilterByStartDate(date);
  }

  const onFilterByEndDateChange = (date) => {
    setFilterByEndDate(date);
  }

  const onClearFilterByDate = () => {
    notifyMessages('','');
    setFilterByStartDate();
    setFilterByEndDate();
  }

  const onDateRangeError = () =>
    notifyMessages(ALERT_ERROR, getI18nMessage("label.daterangepicker.date.range.invalid"));

  /* Checks if the field has more than 5 comma separated words */
  const validateEntityName = (value) => {
    const words = value.split(',').filter(element => element);
    if(words.length > 5) {
      notifyMessages(ALERT_ERROR, getI18nMessage('label.request.details.filter.entity.name.validation'));
      return false;
    } else {
      notifyMessages('','');
      return true;
    }
  }

  const onFilterByEmailTypeChange = (value) => {
    setFilterByEmailType(value);
  }

  useEffect(()=> {
    if(filterByEmail.length > 0 && validateEntityName(filterByEmail)) {
      fetchListWithFilters({ pageNum: 0 })
    }
  },[filterByEmailType])

  const onFilterByTypeChange = (type) => {
    setFilterByType(type);
    setPage(0);
    fetchListWithFilters({ type, pageNum: 0 });
  };

  const onFilterByOrgChange = (value='') => {
    if (value) {
      fetchOrgSuggestions({ name: value });
    }
    setOrgSearchText(value);
  };

  useEffect(() => {
    fetchOrgSuggestions({ name : orgSearchText });
  }, [orgSearchText])

  useEffect(() => {
    if(orgSuggestions && orgSuggestions.length > 0 && assignedOrgSearchText) {
      const org = orgSuggestions.find(org => org.name === assignedOrgSearchText)
      org && setAssignedOrg({ name : org.name, uuid : org.uuid });
    }
  }, [orgSuggestions && orgSuggestions.length])

  const onOrgSelection = (org = {}) => {
    if(!org) org = { name : '', uuid : '' };
    setFilterByOrg(org);
    setOrgSearchText(org.name);
    setPage(0);
    fetchListWithFilters({ org, pageNum: 0 });
  };

  const pageHeaderDescription = getI18nFormattedMessage('label.request.list.page.description', {
    a: msg => (
      <Link href="/admin/console/request-settings">
        {msg}
      </Link>
    ),
  });

  const rows = results.map(
    item => ({ ...item, classes: { root: classes.rowClass } }),
  );

  // Don't render option to filter requests by the type registration for non-admin users
  let requestTypeOptions = APPLICATION_REQUEST_LIST_TYPES;
  if (!hasAdminRole(user)) {
    requestTypeOptions = filter(requestTypeOptions, item => item.uuid !== 'REGISTRATION');
  }

  // Tab logic
  const tabItems = getTabItems({ user });
  const tabs = getTabs(tabItems);
  const defaultIndex = getTabIndex(tabItems, props.match);
  const [tabIndex, setTabIndex] = useState(defaultIndex);
  const [currentTab, setCurrentTab] = useState(tabs[defaultIndex].tabId);
  useEffect(() => {
    const defaultIndex = getTabIndex(tabs, props.match);
    setTabIndex(defaultIndex);
    setCurrentTab(tabs[defaultIndex].tabId);
  }, [props.match]);
  const handleTabChange = (e, newValue) => {
    setTabIndex(newValue);
    const tabId = tabs[newValue].tabId;
    const tabFilterType = tabs[newValue].filterType;
    setCurrentTab(tabId);
    setFilterByType(tabFilterType);
    setPage(0);
    setFilterByName('');
    setFilterByEmail('');
    setFilterByEmailType(REQUEST_FILTER_CONTAINS);
    setFilterByOrg('');
    setOrgSearchText('');
    fetchListWithFilters({
      type: tabFilterType,
      entityField : '',
      filterByStartDate : '',
      filterByEndDate : '',
      org: '',
      pageNum: 0,
      rowsPerPageArg: GRID_ROWS_PER_PAGE_DEFAULT_OPTION,
    });
    if (tabs[newValue].id === 'application') push(`/admin/console/requests`);
    else push(`/admin/console/requests/${tabs[newValue].id}`);
  };
  return (
    <div
      className={classes.content}
      id="requests-page"
      data-layer7-test="requests-page"
    >
      <DetailsContainer
        detailsPageId="requests-list-page"
        isLoading={isLoading}
        classes={classes}
        errors={errors}
        header={
        <>
          <DetailsHeader
            headerId="requests-list-header-container"
            type="textField"
            name={getI18nMessage('label.request.list.page.title')}
            subTitle={pageHeaderDescription}
            pageHeaderTooltipTitle={getI18nMessage('label.request.list.page.title.help')}
            isFieldEdit={false}
            classes={classes}
            showDelete={false}
          />
          <AlertDialog
            id="request-list-accept-reject-dialog"
            data-apim-test="request-list-accept-reject-dialog"
            isOpen={showActionAlert}
            title={actionAlertTitle}
            description={actionAlertDesc}
            disableSubmit={disableActionSubmit}
            submitText={alertSubmitText}
            cancelText={getI18nMessage('label.cancel.button')}
            component={showActionAlert && getAlertDialogInnerComponent()}
            onClose={handleClose}
            onSubmit={handleSubmit}
            onCancel={handleClose}
            showCancel={!isBulkError}
            submitButtonClass={isAcceptAction ? '' : classes.rejectSubmitButton}
          />
        </>
        }
        tabs ={
          <TabsContainer
            id="requests-list-tab-container"
            tabValue={tabIndex}
            orientation="horizontal"
            tabItems={tabs}
            handleTabChange={handleTabChange}
            tabActiveClass={classes.tabActive}
            tabIndicatorClass={classes.tabIndicator}
          />
        }
        page={
        <>
          <TabPanel
            visible={currentTab === "application-requests-list-tab"}
            id="application-requests-list-tab-panel"
            classes={classes.tabPanel}
          >
          <ApplicationRequestsList
            {...props}
            isLoading={isLoading}
            classes={classes}
            notificationStatus={notificationStatus}
            setNotificationStatus={setNotificationStatus}
            notificationMessage={notificationMessage}
            setNotificationMessage={setNotificationMessage}
            onFilterByNameChange={onFilterByNameChange}
            onFilterByNameKeyPress={onFilterByFieldKeyPress}
            filterByName={filterByName}
            requestTypeOptions={requestTypeOptions}
            filterByType={filterByType}
            onFilterByTypeChange={onFilterByTypeChange}
            onFilterByOrgChange={onFilterByOrgChange}
            onOrgSelection={onOrgSelection}
            orgSearchText={orgSearchText}
            orgSuggestions={orgSuggestions}
            filterByOrg={filterByOrg}
            getListColumns={getListColumns}
            rows={rows}
            page={page}
            totalElements={totalElements}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
            onChangePreviousPage={onChangePreviousPage}
            onChangeNextPage={onChangeNextPage}
            notifyMessages={emptyFunction}
            handleAccept={handleAccept}
            handleReject={handleReject}
          />
          </TabPanel>
          <TabPanel
            visible={currentTab === "user-requests-list-tab"}
            id="user-requests-list-tab-panel"
            classes={classes.tabPanel}
          >
            <UserRequestsList
              {...props}
              isLoading={isLoading}
              classes={classes}
              notificationStatus={notificationStatus}
              setNotificationStatus={setNotificationStatus}
              notificationMessage={notificationMessage}
              setNotificationMessage={setNotificationMessage}
              filterByEmail={filterByEmail}
              onFilterByEmailChange={onFilterByEmailChange}
              onFilterByEmailKeyPress={onFilterByFieldKeyPress}
              filterByEmailType={filterByEmailType}
              filterByEmailTypeOptions={REQUESTS_FILTER_EMAIL_TYPE}
              onFilterByEmailTypeChange={onFilterByEmailTypeChange}
              onFilterByOrgChange={onFilterByOrgChange}
              onOrgSelection={onOrgSelection}
              orgSearchText={orgSearchText}
              orgSuggestions={orgSuggestions}
              filterByOrg={filterByOrg}
              getListColumns={getListColumns}
              rows={rows}
              page={page}
              totalElements={totalElements}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={onChangeRowsPerPage}
              onChangePage={onChangePage}
              onChangePreviousPage={onChangePreviousPage}
              onChangeNextPage={onChangeNextPage}
              notifyMessages={emptyFunction}
              handleAccept={handleAccept}
              handleReject={handleReject}
              filterByStartDate={filterByStartDate}
              onFilterByStartDateChange={onFilterByStartDateChange}
              filterByEndDate={filterByEndDate}
              onFilterByEndDateChange={onFilterByEndDateChange}
              onClearFilterByDate={onClearFilterByDate}
              onDateRangeError={onDateRangeError}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
          </TabPanel>
        </>
      }
      />
    </div>
  );
};

RequestsList.propTypes = {
  classes: shape({}),
  fetchList: func,
  fetchOrgSuggestions: func,
  isLoading: bool,
  orgSuggestions: arrayOf(shape({})),
  requestUpdateStatus: string,
  requestBulkUpdateStatus: string,
  requestBulkUpdateResults : object,
  results: arrayOf(shape({})),
  submitRequest: func,
  submitBulkRegistrationRequests: func,
  totalElements: number,
  totalPages: number,
  user: object,
  push: func,
  errors: arrayOf(object),
  bulkSubmitError : object,
  match: shape({}),
};

const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
  orgSuggestions: getOrgSuggestions(state),
  requestUpdateStatus: getRequestUpdateStatus(state),
  requestBulkUpdateStatus: getRequestBulkUpdateStatus(state),
  requestBulkUpdateResults: getRequestBulkUpdateResults(state),
  results: getListResults(state),
  totalElements: getListTotalElements(state),
  totalPages: getListTotalPages(state),
  user: getUserDetails(state),
  errors: getErrors(state),
  bulkSubmitError : getBulkSubmitError(state),
});

const mapDispatchToProps = {
  fetchList,
  fetchOrgSuggestions,
  submitRequest,
  submitBulkRegistrationRequests,
  push,
};

RequestsList.displayName = 'Requests';

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(RequestsList);
